export const menuItems = [
  {
    label: 'Administración',
    items: [
      {
        label: 'Dashboard',
        icon: 'pi pi-fw pi-home',
        routerLink: 'dashboard',
      },
      {
        label: 'Clientes',
        icon: 'pi pi-briefcase',
        routerLink: 'clients',
      },
      {
        label: 'Agentes',
        icon: 'pi pi-fw pi-id-card',
        routerLink: 'agents',
      },
      {
        label: 'Empleados',
        icon: 'pi pi-fw pi-users',
        routerLink: 'employees',
      },
      {
        label: 'Categorías',
        icon: 'pi pi-fw pi-tag',
        routerLink: 'categories',
      },
    ],
  },
  {
    label: 'Operaciones',
    items: [
      {
        label: 'Servicios',
        icon: 'pi pi-fw pi-hammer',
        routerLink: 'services',
      },
      {
        label: 'Presupuestos',
        icon: 'pi pi-fw pi-clipboard',
        routerLink: 'budgets',
      },
    ],
  },
  {
    label: 'Planificación',
    items: [
      {
        label: 'Tablero Kanban',
        icon: 'pi pi-th-large',
        routerLink: 'kanban',
      },
      {
        label: 'Calendario',
        icon: 'pi pi-calendar',
        routerLink: 'calendar',
      },
    ],
  },
  {
    label: 'Configuración',
    items: [
      {
        label: 'Ajustes',
        icon: 'pi pi-fw pi-cog',
        routerLink: 'settings',
      },
    ],
  },
];
